<script>
  import LandingPageItem from './LandingPageItem.svelte'
  import Waiting from './Waiting.svelte'

  import { onMount } from 'svelte';
  import { preloadImage } from './utils.js';

  let config;
  let error;
  let loaded = false;

	onMount(async () => {
    const res = await fetch("config.json");
    let staging = await res.json();
    await preloadImages(staging);
    config = staging;
    document.title = config.title + " Landing Page";
    loaded = true;
  });

  function preloadImages(config) {
    let queue = [];
    if (config.logo) {
      queue.push(preloadImage(config.logo))
    }
    config.items.forEach(function(item) {
      if (item.logo) {
        queue.push(preloadImage(item.logo))
      }
    });
    return Promise.all(queue)
  }
</script>

<style global>
  @tailwind base;
  @tailwind components;
  @tailwind utilities;

  body, html{
    margin:0;
  }
</style>

<div class="h-screen w-full flex justify-center">
{#if !loaded}
<div class="flex h-full justify-center items-center">
  <Waiting/>
</div>
{:else}
<div class="bg-white container flex flex-col md:items-center">
  <header class="py-4 md:py-12 lg:py-20 xl:py-32 flex items-center md:justify-center">
    {#if config.logo}
      <img class="block w-20 h-20 md:w-32 md:h-32 object-contain p-2" src={config.logo} alt={config.title}>
    {/if}
      <div class="text-center font-bold text-2xl md:text-6xl">{config.title}</div>
  </header>

  <div class="md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
    {#each config.items as item}
      <LandingPageItem {item}/>
    {/each}
  </div>
</div>
{/if}
</div>
